import React from 'react'
import Navbar from './Navbar'
import poolrelax from '../poolrelax.jpg'
import atsun from '../atsun.jpg'
import dinerset from '../dinerset.jpg'
import Footer from './Footer'

function Travel() {

    return (
    <>
        <Navbar />
        <div className='travel-main'>
            <div >
                    <img src={poolrelax} alt='pool' className='pool photo' />
            </div>

            
            <div className='travel-column'>
                    <div className='travelA atsun-div'>
                        <img src={atsun} alt='prepared atsun' className='atsun photo' />
                    </div>
                    <div className='travelB content'>
                        <h3>Unveilling Culinary Adventure</h3>
                        <p>At Briggs Flavours, we are dedicated to unveiling culinary adventures and discoveries 
                            through captivating content and expert recommendations. Our mission is to inspire and 
                            guide food enthusiasts and travelers on their journey to explore the diverse and 
                            delectable world of flavors.</p>
 
                        <h3>Embark on Culinary Journey</h3>
                        <p>Immerse yourself in a world of culinary delights as we curate engaging content that 
                            celebrates the art of cooking and the joy of discovery. From mouthwatering recipes 
                            to culinary traditions from around the globe, Briggs Flavours is your companion in 
                            culinary exploration.</p>
                        
                    </div>
                    <div className='travelC diner-div'>
                        <img src={dinerset} alt='diner table' className='diner photo' />
                    </div>
            </div>
            <div className='skyscrape'>
                <h3>EXPLORE TRAVEL WITH US</h3>
                <p>You can be rest assured that by following our recommendations,
                    you are home away from home exploring variety of cuisine,
                    and learning the technique of successful cooking 
                </p>

            </div>
            
        </div>
        <Footer />
    </>

    )
  }

export default Travel